import { render } from "./CollaboratorProposals.vue.js?vue&type=template&id=65bda462!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorProposals.vue?vue&type=template&id=65bda462"
import script from "./CollaboratorProposals.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorProposals.vue?vue&type=script&lang=js"
export * from "./CollaboratorProposals.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorProposals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/CollaboratorProposals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65bda462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65bda462', __exports__)) {
    api.reload('65bda462', __exports__)
  }
  
  module.hot.accept("./CollaboratorProposals.vue.js?vue&type=template&id=65bda462!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorProposals.vue?vue&type=template&id=65bda462", () => {
    api.rerender('65bda462', render)
  })

}


export default __exports__